var filters = {

    selectors: {
        element: '[data-filters="element"]',
        trigger: '[data-filters="trigger"]',
        target: '[data-filters="target"]'
    },

    init: function() {
        var self = this,
            $element = $( self.selectors.element );

        $element.each( function() {
            var $this = $( this ),
                $trigger = $this.find( self.selectors.trigger ),
                $target = $this.find( self.selectors.target );

            $trigger.on( 'click', function() {
                $this.toggleClass( 'opened' );
            } );
        } );

        setTimeout( function() {
            self.sortSelect();
            self.paginationLoader();
        }, 10 );
    },

    sortSelect: function( refresh ) {
        var self = this;
        self.$selects = $( '.shop__filters__sort select' );

        self.$selects.chosen( {
            disable_search: true,
            placeholder_text_single: ''
        } );
    },

    paginationLoader: function() {
        var self = this;

        $( document ).on( 'facetwp-refresh', function() {
            $( '.shop__filters' ).addClass( 'reloading' );
            $( '.shop__pagination' ).addClass( 'reloading' );
        } );

        $( document ).on( 'facetwp-loaded', function() {
            $( '.shop__filters' ).removeClass( 'reloading' );
            $( '.shop__pagination' ).removeClass( 'reloading' );
            self.sortSelect();
        } );
    }

}

export {
    filters
};
